import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { extractErrorMessage } from "../util";
import { TeamData } from "../types";
import Cookies from "js-cookie";

axios.defaults.withCredentials = true;

const base_url = process.env.REACT_APP_BASE_URL;
//token
// const headerToken = Cookies.get("token");

interface AuthState {
  error?: string | null;
  isLoading: boolean;
  teams: {
    data: Array<{
      id: number;
      first_name: string;
      last_name: string;
      email: string;
      phone: string;
      created_at: Date;
      active: number;
      roles: Array<{
        name: string;
      }>;
    }>;
    total: number;
  } | null;
}

const initialState: AuthState = {
  error: null,
  isLoading: false,
  teams: null,
};
export const getAllUsers = createAsyncThunk(
  "api/getAllUser",
  async (_, thunkAPI) => {

    const headerToken = Cookies.get("token")
    try {
      const response = await axios.get(`${base_url}/getAllUsers`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {}
  }
);

export const inviteUser = createAsyncThunk(
  "api/inviteUser",
  async (data: TeamData, thunkAPI) => {

    const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/inviteUser`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);


export const reInviteUser = createAsyncThunk(
  "api/reInviteUser",
  async (data: any, thunkAPI) => {

    const headerToken = Cookies.get("token")
    try {
      const response = await axios.post(`${base_url}/reInviteUser`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

export const updateRole = createAsyncThunk(
  "api/updateRole",
  async (data: any, thunkAPI) => {

    const headerToken = Cookies.get("token")
    try {
      const response = await axios.put(`${base_url}/updateRole`, data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${headerToken}`,
        },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractErrorMessage(error));
    }
  }
);

// Redux slice for authentication
const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(inviteUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(inviteUser.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(inviteUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(getAllUsers.pending, (state, action) => {
        state.isLoading = true;
        state.teams = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.teams = action.payload;
        state.isLoading = false;
      });
  },
});

export default teamSlice.reducer;
